// extracted by mini-css-extract-plugin
export default {"container":"S03_container__7VVn9","limiter":"S03_limiter__ntBUx"};